import React from 'react';
import { bool, func, object, shape, string } from 'prop-types';

import CircularProgress from '@material-ui/core/CircularProgress';

import ClientsTargetSelect from './ClientsTargetSelect';
import EquipmentTargetSelect from './EquipmentTargetSelect';
import SidebarPanel from '../../SidebarPanel';
import SitesTargetSelect from './SitesTargetSelect';
import SystemsTargetSelect from './SystemsTargetSelect';

import classes from './RuleTargetsFieldset.module.css';

const RuleTargetsFieldset = ({
    companyId,
    disabled,
    errors,
    onBlur,
    onChange,
    onPatch,
    touched,
    values
}) => {
    const panelProps = {
        id:           'rule-target-filter',
        key:          'ruleTargetFilter',
        title:        'Rule Target Filter',
        titleIconSrc: '/assets/images/rulesIconColor.svg'
    };

    if (!companyId) {
        return (
            <SidebarPanel {...panelProps}>
                <aside className={classes.panelLoading}>
                    <CircularProgress />
                </aside>
            </SidebarPanel>
        );
    }

    return (
        <SidebarPanel {...panelProps}>
            <div
                aria-labelledby={panelProps.id}
                className={classes.fieldset}
                role="group"
            >
                <ClientsTargetSelect
                    companyId={companyId}
                    errors={errors}
                    disabled={disabled}
                    onBlur={onBlur}
                    onPatch={onPatch}
                    touched={touched}
                    values={values}
                />
                <SitesTargetSelect
                    companyId={companyId}
                    errors={errors}
                    disabled={disabled}
                    onBlur={onBlur}
                    onPatch={onPatch}
                    touched={touched}
                    values={values}
                />
                <SystemsTargetSelect
                    errors={errors}
                    disabled={disabled}
                    onBlur={onBlur}
                    onChange={onChange}
                    onPatch={onPatch}
                    touched={touched}
                    values={values}
                />
                <EquipmentTargetSelect
                    errors={errors}
                    disabled={disabled}
                    onBlur={onBlur}
                    onChange={onChange}
                    onPatch={onPatch}
                    touched={touched}
                    values={values}
                />
            </div>
        </SidebarPanel>
    );
};

RuleTargetsFieldset.defaultProps = {
    disabled: false,
    errors:   {},
    onBlur:   () => {},
    onChange: () => {},
    touched:  {}
};

RuleTargetsFieldset.propTypes = {
    companyId: string,
    disabled:  bool,
    errors:    object,
    onBlur:    func,
    onChange:  func,
    onPatch:   func,
    touched:   object,
    values:    shape({
        target: string
    })
};

export default RuleTargetsFieldset;
